import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { DefaultAmountCard } from '../../../components';
import { DefaultAmountOptionsSkeleton } from '../../../components/skeletons/CheckoutPage/DefaultAmountOptions';

export function DefaultAmountOptions({ handleAmountChange, donationAmount }) {
	const donationDetails = useSelector((state) => state.donationCheckout);

	const defaultAmountOptions = useSelector((state) =>
		donationDetails.isRecurring ? state.currencyDefaultAmountOptions.recurring : state.currencyDefaultAmountOptions.nonRecurring,
	);
	const [amountValues, setAmountValues] = useState([]);

	useEffect(() => {
		if (defaultAmountOptions) {
			const defaultAmountValues = [];
			defaultAmountOptions.map((amount) => {
				defaultAmountValues.push(amount.default_value);
			});
			setAmountValues(defaultAmountValues);
		}
	}, [defaultAmountOptions]);

	return defaultAmountOptions.length ? (
		<Box className="AmountOptions">
			{defaultAmountOptions &&
				defaultAmountOptions.map((option) => {
					return (
						<Box key={option.id}>
							<DefaultAmountCard key={option.id} currency={option} handleDefaultAmountSelect={handleAmountChange} donationAmount={donationAmount} />
						</Box>
					);
				})}
		</Box>
	) : (
		<DefaultAmountOptionsSkeleton />
	);
}
